// lib
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

// entities
import { loginLogic, toastLogic } from '@_features/auth';
import { notificationApi } from '@_entities/user';

// shared
import { SubtractStrokeIcon, TTKLogoIcon, UnionIcon } from '@_shared/icons';

// local
import * as S from './LogoHeader.style';

export function LogoHeader() {
	const navigate = useNavigate();

	const [isNotificationRemind, setNotificationRemind] = useState<boolean>(false);

	useEffect(() => {
		// check&set isNotification Remind
		notificationApi.reminder().then(({ data: { reminder } }) => {
			setNotificationRemind(reminder);
		});
	}, []);

	return (
		<S.Header>
			<TTKLogoIcon />
			<S.HeaderIcons>
				<S.NotificationIconWrapper isNotificationRemind={isNotificationRemind}>
					<UnionIcon
						onClick={() => {
							if (loginLogic.isLogin()) {
								navigate('/notifications');
							} else {
								toastLogic.loginToast();
							}
						}}
					/>
				</S.NotificationIconWrapper>
				<SubtractStrokeIcon
					onClick={() => {
						if (loginLogic.isLogin()) {
							navigate('/settings');
						} else {
							toastLogic.loginToast();
						}
					}}
				/>
			</S.HeaderIcons>
		</S.Header>
	);
}
